// extracted by mini-css-extract-plugin
export default {"leftPanelWrapper":"leftPanelWrapper__2F-kk","leftPanelWrapperMobile":"leftPanelWrapperMobile__1XWKw"};